// extracted by mini-css-extract-plugin
export default {"upButton":"UpButton_upButton__0PAxV"};